import { TradesPanel } from "../components/TradesPanel";
import { useTradesPoll } from "../hooks/useTradesPoll";

export function TradesPage() {
  const trades = useTradesPoll();
  return (
    <div className="flex flex-col gap-4">
      <h1 className="text-xl font-bold tracking-tight">Trades</h1>
      <TradesPanel trades={trades} />
    </div>
  );
}
